import { useSpring, animated } from "react-spring";
import React, { useState } from "react";
export const Shake = ({ animate, children, ...props }) => {
	const { x } = useSpring({
		from: { x: 0 },
		x: animate ? 1 : 0,
		config: { mass: 1, tension: 100, friction: 30 },
	});
	return (
		<animated.div
			style={{
				transformOrigin: "center center",
				transform:
					animate &&
					x
						.interpolate({
							range: [0, 0.2, 0.4, 0.6, 0.8, 1],
							output: [30, -30, 15, -15, 0, 0],
						})
						.interpolate((x) => `translate(${x}px)`),
			}}
			{...props}
		>
			{children}
		</animated.div>
	);
};
